import {
	UPDATE_WAITING_TIME_SCHEDULE_ENTRY,
	SET_WAITING_TIME_SCHEDULE_ENTRY,
	RESET_WAITING_TIME_SCHEDULE_ENTRY,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './waitingTimeScheduleEntries.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		defaultWaitingTimeScheduleEntry: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				products: 0,
				minutes: 0,
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_WAITING_TIME_SCHEDULE_ENTRY: {
			return {
				data: {
					defaultWaitingTimeScheduleEntry: payload,
				},
			};
		}

		case UPDATE_WAITING_TIME_SCHEDULE_ENTRY: {
			return {
				data: {
					defaultWaitingTimeScheduleEntry: {
						...state.data.defaultWaitingTimeScheduleEntry,
						...payload,
					},
				},
			};
		}

		case RESET_WAITING_TIME_SCHEDULE_ENTRY: {
			return {
				...defaultState,
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
